import { render } from "./ListeRecensement.vue?vue&type=template&id=1f62a238&ts=true"
import script from "./ListeRecensement.vue?vue&type=script&lang=ts"
export * from "./ListeRecensement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__